const initialState = {
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/arquivos/redux/initialState.js